import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { EvaluationSubjectGoalInterface } from '../+models';

export const EVALUATION_SUBJECT_GOAL_SERVICE_TOKEN = new InjectionToken('EvaluationSubjectGoalServiceInterface');

export interface EvaluationSubjectGoalServiceInterface {
  getEvaluationSubjectGoalsForBook(bookId: number): Observable<EvaluationSubjectGoalInterface[]>;
}
